import React, { useState, useContext } from "react";

import { PlusIcon } from "@heroicons/react/24/solid";
import { FormattedMessage } from "react-intl";
import Button from "../../ui-components/Button";
import CountryContext from "../../CountryContext";
import AuthenticationService from "../../services/AuthenticationService";
import Modal from "../../ui-components/Modal";
import ImageUploader from "./ImageUploader";

const ImageEditorContainer = ({ isEditingImage, children }) => {
  return (
    <Modal large opened={!!isEditingImage}>
      {isEditingImage ? <div className="p-5 xl:p-10">{children}</div> : <></>}
    </Modal>
  );
};

export const MapsSectionImageUploader = ({
  onImageChoosed,
  section,
  uploadingImage,
  setUploadingImage,
}) => {
  const [isEditingImage, setIsEditingImage] = useState(false);
  const { country } = useContext(CountryContext);
  const userId = AuthenticationService.getUserData().id;

  return (
    <>
      <ImageUploader
        prefix={`images/${country.code}/tasks/maps/${userId}`}
        bucket="task_images"
        uploading={uploadingImage}
        setUploading={setUploadingImage}
        setIsEditingImage={setIsEditingImage}
        onUploadComplete={async (url) => {
          onImageChoosed(url);
        }}
        accept={section === "planimetries" ? "application/pdf" : "image/*"}
        allowEdit={true}
        EditorContainerComponent={ImageEditorContainer}
      >
        {!isEditingImage && (
          <Button full submitting={uploadingImage}>
            <PlusIcon className="-ml-0.5 w-4" />
            <FormattedMessage id="add" />
          </Button>
        )}
      </ImageUploader>
    </>
  );
};
